import { t as e } from "../chunks/cn.CW-jpn-X.js";
import { XIcon as t } from "lucide-react";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { Transforms as i } from "slate";
// lib/components/FocusBlock.tsx
var a = ({ children: a, className: o, editor: s, element: c, removable: l }) => {
	let u = !!s && !!c && s.children[0]?.id === c.id;
	return /* @__PURE__ */ n("div", {
		className: e("relative", l && "group", o, u && "mb-3", !u && "my-3"),
		children: /* @__PURE__ */ r("div", {
			className: "relative rounded",
			children: [l && s && c && /* @__PURE__ */ n("div", {
				contentEditable: !1,
				className: "absolute hidden right-1 top-1 size-8 w-fit text-slate-900 dark:text-white justify-between items-center group-hover:block z-50",
				children: /* @__PURE__ */ n("div", {
					className: e("p-1 rounded opacity-70 bg-slate-200 hover:opacity-100 dark:bg-gray-700"),
					onMouseDown: (e) => {
						e.preventDefault(), e.stopPropagation();
						let t = s.children.findIndex((e) => e.id === c.id);
						t > -1 && i.removeNodes(s, { at: [t] });
					},
					children: /* @__PURE__ */ n(t, { size: 15 })
				})
			}), a]
		})
	});
};
export { a as Block };
